document.addEventListener('click', function (e) {
  const arBtn = e.target.closest('.btn-ar.mobile-only');
  const dimBtn = e.target.closest('.btn-dimensions');

  if (arBtn) {
    const modelMedia = arBtn.closest('model-media');
    const viewer = modelMedia ? modelMedia.querySelector('model-viewer') : null;

    if (viewer && typeof viewer.activateAR === 'function') {
      viewer.activateAR();
    } else {
      alert('Tu dispositivo no soporta Realidad Aumentada. Intenta desde un móvil compatible 📱');
    }
    return;
  }

  if (dimBtn) {
    const modelMedia = dimBtn.closest('model-media');
    if (!modelMedia) return;

    const isVisible = modelMedia.classList.toggle('dimensions-visible');
    dimBtn.setAttribute('aria-pressed', isVisible ? 'true' : 'false');
    dimBtn.textContent = isVisible ? '📏 Ocultar medidas' : '📏 Ver medidas';
  }
});